import Vue from 'vue'
import Vuex from 'vuex'
import map from './store/map'
import trips from './store/trips'
import debug from './store/debug'
import axios from 'axios'
import controls from './store/controls'
import auth from './store/auth'
import analytics from './store/analytics'
import searchPlugin, { SearchApi } from 'vuex-search'
import { langFilter } from './helpers/general'
import { config } from './plugins/axios'
import Tags from './store/admin/Tags/tags'
import Payments from './store/admin/subscriptions'
import Insurances from './store/admin/insurances'
import Units from './store/admin/units'
import Accounts from './store/admin/accounts'
import Sims from './store/admin/sims'
import VendorManagement from '@/store/admin/vendor_management'
import MaintenancePlans from '@/store/admin/maintenance_plans'
import UserManagement from '@/store/admin/user_management'
import { encrypt } from './helpers/crypt'
import { EventBus } from '@/helpers/event.bus'
import { apiGetAuthenticatedUser } from './api'
import { mutations as newStateMutations } from './state'
// import modules$ from './store/modules'

const allSubstringsSearchApi = new SearchApi()

Vue.use(Vuex)

/**
 * Create the root state for the store.
 */
export const state = {
  report: [],
  value: '',
  timezone: '',
  user: {
    permissions: []
  },
  locale: 'en',
  locales: [
    {
      key: 'nl',
      name: 'Dutch',
      code: 'nl',
      icon: require('@/assets/flags/nl.svg')
    },
    {
      key: 'de',
      name: 'German',
      code: 'de',
      icon: require('@/assets/flags/de.svg')
    },
    {
      key: 'en',
      name: 'English',
      code: 'en',
      icon: require('@/assets/flags/en.svg')
    },
    {
      key: 'fr',
      name: 'Français',
      code: 'fr',
      icon: require('@/assets/flags/fr.svg')
    }
  ],
  socket: null
}

export const getters = {
  getLocales: (state) => state.locales
}

/**
 * Create the mutations for the store state.
 */
export const mutations = {
  setReport: (state, { report }) => {
    state.report = report
  },
  setLocale (state, { lang }) {
    state.locale = lang
  },
  setTimezone (state, { zone }) {
    state.timezone = zone
  },
  setUser (state, { user }) {
    state.user = user
  },
  setSocket (state, { socket }) {
    state.socket = socket
  }
}

/**
 * Create store actions.
 */
export const actions = {

  async initLocale () {
    EventBus.$emit('INIT_LOCALE')
  },

  async setLocale ({ commit, state }, { lang }) {
    if (!lang) {
      console.log('Language not provided, getting default language from browser!')
      const langCode = navigator.language || navigator.userLanguage
      const index = state.locales.findIndex(locale => locale.code === langFilter(langCode))

      if (index !== -1) {
        lang = state.locales[index]
      }
    }

    EventBus.$emit('setLocale', lang)

    // Store in state.
    commit('setLocale', { lang })

    // Store in local storage!
    const jsonString = JSON.stringify(lang)
    localStorage.setItem('lang', encrypt(jsonString))
  },

  async initialize ({ commit }, { loading, authenticated, accessToken }) {
    const api = axios.create(config)
    api.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    try {
      const { data } = await apiGetAuthenticatedUser()
      const user = data.data

      if (user.permissions.length < 1) user.permissions = ['none']
      const levels = ['department', 'company', 'vendor', 'enterprise']
      const parent = levels.filter(l => user[`${l}_id`])

      user.parent = parent
      user.parent_id = user[`${parent}_id`]

      newStateMutations.setUser(user)
      await commit('Auth/setAuthenticated', { authenticated })
      await commit('setUser', { user })
      await commit('Auth/setUser', { user })
    } catch (e) {
      console.log(e)
      await commit('setUser', { user: 'error' })
    } finally {
      commit('Auth/setLoading', { loading })
    }
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    // ...modules$,
    Auth: auth,
    Controls: controls,
    Map: map,
    Trips: trips,
    Analytics: analytics,
    Debug: debug,
    Admin: {
      namespaced: true,
      modules: {
        Tags,
        Units,
        Sims,
        Accounts,
        Insurances,
        Payments,
        VendorManagement,
        UserManagement,
        MaintenancePlans
      }
    }
  },
  plugins: [
    searchPlugin({
      resources: {
        markers: {
          index: ['slug'],
          getter: state => state.Map.markers,
          watch: {
            delay: 500,
            reindex: true
          }
        },
        notifications: {
          index: ['name', 'entity_name', 'user_name', 'trigger_name', 'trigger_value', 'trigger_metric', 'trigger_type'],
          getter: state => state.Admin.MaintenancePlans.notifications,
          watch: {
            delay: 500,
            reindex: true
          }
        }
      },
      searchApi: allSubstringsSearchApi
    })
  ]
})
